<template>
  <div
    class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center"
  >
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500">
            New Refund
          </div>
          <div v-else class="text-2xl font-bold text-blue-500">Edit Refund</div>
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6 pt-2">
             <div class="md:flex mb-6 border p-5 border-dotted rounded-md border-gray-500">
                  <div class="md:w-1/3 px-3">
                        <div class="border-2 h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                              <label for="seller" class="bg-white text-gray-700 px-1">Country (warehouse) <span :class="$colors.required">*</span></label>
                              </p>
                          </div>
                          <p>
                          <v-select @input="setSelectedW" :options="warehouses" label="name">
                              <template slot="option" slot-scope="option">
                                  <img class="flag-img" :src="option.flag"/>
                                    {{ option.countryName}} 
                              </template>
                            </v-select>
                          </p>
                      </div>
                  </div>
                  <div  class="md:w-1/3 px-3 mb-6 md:mb-0">
                      <div class="border-2 h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                              <label for="seller" class="bg-white text-gray-700 px-1">Select Seller <span :class="$colors.required">*</span></label>
                              </p>
                          </div>
                          <p>
                              <v-select label="fullName" @search="getUsersDebance($event,'shipsen')"  :options="sellers" @input="setSelectedSeller"> </v-select>
                          </p>
                      </div>
                  </div>
                  <div class="md:w-1/3 px-3">
                        <div class="border-2 h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                              <label for="seller" class="bg-white text-gray-700 px-1">Select Order<span :class="$colors.required">*</span></label>
                              </p>
                          </div>
                          <p>
                            <v-select @input="setSelectedOrder" @search="searchOrder($event,'shipsen')" label="id" v-model="id_order" :options="orders"> 
                                <template slot="option" slot-scope="option">
                                    <!-- {{ $f.getIdbySplit(option.id)}}  -->
                                    {{ option.id }} 
                              </template>
                            </v-select>
                          </p>
                      </div>
                  </div>
              </div>
              <section class="relative border p-5 border-dotted rounded-md border-gray-500" v-if="item._id">
                 <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                  <div class="flex bg-white w-full space-x-2">
                        <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                            <div class="flex w-full mt-1">
                                <span class="rounded-full h-12 w-12 bg-gray-200">
                                    <i class="material-icons p-3 text-blue-400">person</i>
                                </span>

                                <div class="ml-5 w-full pb-4">
                                    <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                        Customer information
                                    </div>
                                    <div class="text-sm font-light text-gray-500"></div>
                                    <div class="w-full space-y-4">
                                        <div class="flex">
                                            <div
                                                class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                    <p>
                                                        <label for="customerFullName"
                                                            class="bg-white text-gray-700 px-1">Full name
                                                            <span :class="$colors.required">*</span></label>
                                                    </p>
                                                </div>
                                                <p>
                                                    <input :id="'customerFullName'" autocomplete="false"
                                                        tabindex="0" type="text" v-model="item.customer.fullName"
                                                        class="py-2 text-xs px-2 outline-none block h-full w-full"
                                                        disabled />
                                                </p>
                                            </div>
                                        </div>

                                        <div
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="customerPhone" class="bg-white text-gray-700 px-1">Phone
                                                        <span :class="$colors.required">*</span></label>
                                                </p>
                                            </div>
                                            <p>
                                                <input :id="'customerPhone'" autocomplete="false" tabindex="0"
                                                    type="text" v-model="item.customer.phone"
                                                    class="py-2 text-xs px-2 outline-none block h-full w-full" disabled />
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                          <!-- ****************************** Order Information *********************************************-->

                    <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                        <div class="flex w-full mt-1">
                            <span class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-blue-400">local_grocery_store</i>
                            </span>

                            <div class="ml-5 w-full">
                                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                     Order Information
                                </div>

                                <div class="w-full">
                                  
                                    <div class="flex">
                                      
                                        <div 
                                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                                <p>
                                                    <label for="status" v-bind:style="{
                                                    borderColor: item.status.color,
                                                    }" class="bg-white text-gray-700 px-1">Status
                                                        <span :class="$colors.required">*</span>
                                                    </label>
                                                </p>
                                            </div>
                                            <p>
                                              <input v-bind:style="{
                                                    color: item.status.color,
                                                    borderColor: item.status.color,}" autocomplete="false"
                                                        tabindex="0" type="text" v-model="item.status.name"
                                                        class="py-2 text-xs px-2 outline-none block h-full w-full"
                                                        disabled />
                                            </p>
                                        </div>
                                    </div>
                                  
                                  <div class="py-5">
                                    <div class="tab-content">
                                      <div id="latest-tasks-new" class="tab-pane active">
                                          <div class="flex items-center">
                                              <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                                 <span  class="font-medium">Order #</span>
                                                 <div class="text-gray-600">{{ item.id }}</div>
                                               </div>
                                          </div>
                                          <div class="flex items-center mt-5">
                                            <div class="border-l-2 border-blue-600 dark:border-blue-500 pl-4">
                                              <span  class="font-medium">Refund</span>
                                              <div class="text-gray-600">{{item.totalPrice}} <sup>{{item.warehouse.currency}}</sup></div>
                                            </div>
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                    <!--*******************  Product Order ***************************************-->
                    <div class="flex w-full justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                        <div class="flex w-full mt-1">
                            <span class="rounded-full h-12 w-12 bg-gray-200">
                                <i class="material-icons p-3 text-blue-400">local_mall</i>
                            </span>

                            <div class="ml-5 w-full pb-4">
                                <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                                    Order Products
                                </div>

                                <div class="w-full space-y-4">
                                    <div class="w-full">
                                        <table style="display: inline-table;"
                                            class="w-full flex flex-row flex-no-wrap sm:bg-white rounded-md overflow-hidden sm:shadow-xs">
                                            <thead class="text-white">
                                                <tr
                                                    class="bg-blue-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                                                    <th class="p-2 justify-center">Products</th>
                                                    <th class="p-2 justify-center">Quantity</th>
                                                    <th class="p-2 justify-center">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody class="flex-1 sm:flex-none" v-for="it in item.details" :key="it._id">
                                                <tr class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                                                    <td
                                                        class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2">
                                                        <div class="flex space-x-10">
                                                            <div>
                                                                <img alt="..."
                                                                    :src="it.product.picture"
                                                                    class="h-16 w-16 rounded-md mx-auto" />
                                                            </div>
                                                            <div>
                                                                {{ it.product.name }}
                                                                <p class="font-light">
                                                                    Price : {{ it.product.price }} {{item.warehouse.currency}}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td
                                                        class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                        {{ it.quantity }}
                                                    </td>
                                                    <td
                                                        class="border-grey-light text-xs justify-center border hover:bg-gray-100 p-2 truncate">
                                                        {{ it.quantity * it.product.price }} {{item.warehouse.currency}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                  <div class="mt-6 pt-3 flex justify-end">
                        <button
                          class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
                          @click="save"
                        >
                          Create refund
                        </button>
                  </div>
               </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      formData: {},
      sellers: [],
      limit:10,
      id_order:"",
      item:{},
      orders:[],
      warehouses:[],
      loading:false,
      fullPage: false,
    };
  },

  async mounted() {
    await this.getWarehouses();
  },
  methods: {
     RouterBack: function() {
       this.$router.back();
    },
    setSelectedOrder(order){
       if(order){
         this.loading = true
         this.item=order;
         this.id_order=order.id;
         setTimeout(() => (this.loading = false), 1200);
       }else {this.item={};this.id_order=""}
    },
    async setSelectedSeller(seller){
       if(seller){
          this.formData.seller=seller._id;
           await this.getOrders()
       }else delete this.formData.seller;
    },
    async setSelectedW(warhouse){
       if(warhouse){
            this.orders =[];this.sellers=[];
            this.formData.warhouse=warhouse._id;
            await this.getSellers(warhouse._id)
            console.log('warhouse----',warhouse)
       }else delete this.formData.warhouse;
    },
    getUsersDebance: _.debounce(async function(name) {
      if(this.formData.warhouse){
          await this.$store.dispatch('wharhouse/searchUser',{type: "Seller",warhouse:this.formData.warhouse,search:name}).then((res) => {
          this.sellers = res
        })
      }
   }, 500), 
   searchOrder: _.debounce(async function(search) {
      if(this.formData.warhouse && this.formData.seller){
        const filter = {
            limit:10,
            seller:this.formData.seller,
            warehouse:this.formData.warhouse,
            idOrder: search,
            };  
            const res= await this.$server.find("orders",filter);   
        if (res.content.results) this.orders = res.content.results;
        else this.orders = [];
      }
    }, 500),
    async getSellers(warehouse) {
      const filter = {
         type: "Seller",
         warehouses:warehouse,
         limit:10,
      };
      const res = await this.$server.search("users", filter);
        if (res.content.results) this.sellers = res.content.results;
        else this.sellers = [];
    },
    async getOrders() {
      if(this.formData.warhouse && this.formData.seller){
          const filter = {
            seller:this.formData.seller,
            warehouse:this.formData.warhouse,
            limit:10,
          };
          const res = await this.$server.search("orders", filter);
            if (res.content.results) this.orders = res.content.results;
            else this.orders = [];
      }  
    },
    async getWarehouses(){
      this.warehouses = this.currentUser.warehouses;
        // const filter = {limit:1000};
        // const res = await this.$server.search("warehouses",filter);
        // if (res.content.results) {
        //      this.warehouses = res.content.results;
        // } else this.warehouses = [];
    }, 
    async save() {
      if(this.item._id){
         const shipping = await this.$server.get("shippings", {order: this.item._id});
         if(shipping.content && shipping.content._id){
               this.item.shipping=shipping.content._id;
               this.$confirm("Are you sure to create refund for this orders ?").then(async (res) => {
                if(res){
                  const ress = await this.$server.create("refunds", this.item);
                  if (ress) {
                      this.item = {};this.id_order="";this.orders=[]
                      alert("Refund created !", "success");
                    }
                }
          }); 
         }else alert("No shipping found for this order !!", "error");  
         
      }else alert("An error occurred, please reload the page and try again !!", "error");  
    },
    
    
    
  },
};
</script>
<style >
.icon::after {
  content: "";
  display: block;
  position: absolute;
  border-top: 23px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 12px solid #3182ce;
  left: 100%;
  top: 0;
}
</style>
